import './footer.scss'
import React from 'react'

const Footer: React.FC = () => <footer></footer>

export default Footer
